import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Mail, Phone, MapPin } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-gray-800 text-white" data-id="element-280">
      <div className="container mx-auto px-4 py-12" data-id="element-281">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-282">
          {/* About section */}
          <div data-id="element-283">
            <h3 className="text-xl font-bold mb-4" data-id="element-284">About e-Services</h3>
            <p className="text-gray-300 mb-4" data-id="element-285">
              The official platform for government services, providing citizens,
              businesses and visitors with easy access to public services.
            </p>
            <div className="flex space-x-4" data-id="element-286">
              <a href="#" className="text-white hover:text-blue-400" data-id="element-287">
                <Facebook className="h-5 w-5" data-id="element-288" />
              </a>
              <a href="#" className="text-white hover:text-blue-400" data-id="element-289">
                <Twitter className="h-5 w-5" data-id="element-290" />
              </a>
              <a href="#" className="text-white hover:text-blue-400" data-id="element-291">
                <Instagram className="h-5 w-5" data-id="element-292" />
              </a>
            </div>
          </div>
          {/* Quick Links */}
          <div data-id="element-293">
            <h3 className="text-xl font-bold mb-4" data-id="element-294">Quick Links</h3>
            <ul className="space-y-2" data-id="element-295">
              <li data-id="element-296">
                <Link to="/" className="text-gray-300 hover:text-white" data-id="element-297">
                  Home
                </Link>
              </li>
              <li data-id="element-298">
                <Link to="/services" className="text-gray-300 hover:text-white" data-id="element-299">
                  Services
                </Link>
              </li>
              <li data-id="element-300">
                <Link to="/news" className="text-gray-300 hover:text-white" data-id="element-301">
                  News & Updates
                </Link>
              </li>
              <li data-id="element-302">
                <Link to="/faqs" className="text-gray-300 hover:text-white" data-id="element-303">
                  FAQs
                </Link>
              </li>
              <li data-id="element-304">
                <Link to="/terms" className="text-gray-300 hover:text-white" data-id="element-305">
                  Terms & Conditions
                </Link>
              </li>
              <li data-id="element-306">
                <Link to="/privacy" className="text-gray-300 hover:text-white" data-id="element-307">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
          {/* Services */}
          <div data-id="element-308">
            <h3 className="text-xl font-bold mb-4" data-id="element-309">Services</h3>
            <ul className="space-y-2" data-id="element-310">
              <li data-id="element-311">
                <Link to="/services/business" className="text-gray-300 hover:text-white" data-id="element-312">
                  Business Registration
                </Link>
              </li>
              <li data-id="element-313">
                <Link to="/services/immigration" className="text-gray-300 hover:text-white" data-id="element-314">
                  Immigration & Visa
                </Link>
              </li>
              <li data-id="element-315">
                <Link to="/services/civil" className="text-gray-300 hover:text-white" data-id="element-316">
                  Civil Registration
                </Link>
              </li>
              <li data-id="element-317">
                <Link to="/services/permits" className="text-gray-300 hover:text-white" data-id="element-318">
                  Permits & Licenses
                </Link>
              </li>
              <li data-id="element-319">
                <Link to="/services/taxes" className="text-gray-300 hover:text-white" data-id="element-320">
                  Tax Services
                </Link>
              </li>
            </ul>
          </div>
          {/* Contact */}
          <div data-id="element-321">
            <h3 className="text-xl font-bold mb-4" data-id="element-322">Contact Us</h3>
            <ul className="space-y-3" data-id="element-323">
              <li className="flex items-start" data-id="element-324">
                <MapPin className="h-5 w-5 mr-2 mt-0.5 text-gray-300" data-id="element-325" />
                <span className="text-gray-300" data-id="element-326">
                African Ave, Addis Aababa, Ethiopia
                </span>
              </li>
              <li className="flex items-center" data-id="element-327">
                <Phone className="h-5 w-5 mr-2 text-gray-300" data-id="element-328" />
                <span className="text-gray-300" data-id="element-329">+251 700 000 000</span>
              </li>
              <li className="flex items-center" data-id="element-330">
                <Mail className="h-5 w-5 mr-2 text-gray-300" data-id="element-331" />
                <span className="text-gray-300" data-id="element-332">support@onestop.gov.et</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-10 pt-6 text-center text-gray-300" data-id="element-333">
          <p data-id="element-334">
            &copy; {new Date().getFullYear()} e-Services Portal. All rights
            reserved.
          </p>
          <p className="mt-2 text-sm" data-id="element-335">
            A government initiative to digitize public services.
          </p>
        </div>
      </div>
    </footer>;
};